// removed by extract-text-webpack-plugin
module.exports = {"container":"_28qLSK8lmKPQtR8rlItHBv"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/styles.css
// module id = 1592
// module chunks = 83